import styled from 'styled-components';
import Button from '@material-ui/core/Button';
export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  span {
    text-transform: none;
    font-size: 13px;
    font-family: 'OpenSans-Regular';
    font-weight: 500;
    opacity: 0.87;
    line-height: 22px;
  }
`;
export const WrapperReco = styled.div`
  align-self: flex-end;
  span {
    text-transform: none;
    font-size: 13px;
    margin-left: 0px;
    font-family: 'OpenSans-Regular';
    font-weight: 500;
    opacity: 0.87;
  }
  button {
    margin-top: 0px !important;
  }
`;
export const ButtonStyle = styled(Button)`
  && {
    min-width: 24px;
    text-transform: none;
    height: 36px;
    .MuiButton-startIcon {
      margin-left: 0px;
      margin-right: 0px;
    }
  }
`;
export const StyledWrapper = styled.div`
  display: flex;
  padding: 3px 0px;
  justify-content: ${props => !props.showApplyReco && !props.showCard ? '' : 'space-between'};
  align-items: center;
`;
export const Logo = styled.img`
  margin-right: 6px;
`;
export default {
  Wrapper,
  ButtonStyle,
  WrapperReco,
  StyledWrapper,
  Logo
};